import ajax from '@/libs/Ajax'

let NAME_SPACE = "aseapi/console/rsrcmgr/connmgr";

export default {
    queryConnList(params) {
        return ajax.get(`${NAME_SPACE}/listConn`, {params})
    },
    delConn(params) {
        return ajax.post(`${NAME_SPACE}/deleteConn`, params)
    },
    saveConn(data) {
        return ajax.post(`${NAME_SPACE}/saveConn`, data)
    },
    updateConn(data) {
        return ajax.post(`${NAME_SPACE}/updateConn`, data)
    },
    checkConn(data) {
        return ajax.post(`${NAME_SPACE}/checkConn`, data, {message: false})
    },
    checkConnName(params) {
        return ajax.get(`${NAME_SPACE}/checkConnName`, {params})
    },
    checkConnType(params) {
        return ajax.get(`${NAME_SPACE}/checkConnType`, {params})
    },


    connExport(data) {
        return ajax.post(`${NAME_SPACE}/connExport`, data)
    },
    connImport(data) {
        return ajax.post(`${NAME_SPACE}/connImport`, data)
    }
}